import {ConversationSortPropertiesEnum} from '../../../../models/api/conversationCommonTypes';
import {CellsSortDirectionsEnum, SortOptionModel} from '../../../../models/api/sortOptionModel';
import {InboxesParameters, InboxesParametersTypesEnum} from '../../inboxes/parameters/inboxesParameters';
import {
  CellsSortModesEnum,
  findParametersCellsSortMode,
} from '../../inboxes/parameters/inboxesParametersHelpers';

export enum VisualSortOptionsEnum {
  NEWEST,
  OLDEST,
  NEWEST_UNREPLIED,
  OLDEST_UNREPLIED,
  DUE_DATE,
}

export function sortOptionFromVisualSortOption(
  parameters: InboxesParameters,
  visualSortOption: VisualSortOptionsEnum,
): SortOptionModel {
  // Find the new sort direction for the specified option.
  const sortDirection = sortDirectionFromVisualSortOption(visualSortOption);
  const search = parameters.type !== InboxesParametersTypesEnum.TEAMMATE_MESSAGES && parameters.search;

  // If needed, also update the sort property.
  switch (findParametersCellsSortMode(parameters)) {
    case CellsSortModesEnum.MESSAGE:
      return {sortDirection, sortProperty: undefined};

    default:
      return {
        sortDirection,
        sortProperty: sortPropertyFromVisualSortOption(visualSortOption, Boolean(search)),
      };
  }
}

function sortDirectionFromVisualSortOption(sortOption: VisualSortOptionsEnum) {
  switch (sortOption) {
    case VisualSortOptionsEnum.NEWEST:
    case VisualSortOptionsEnum.NEWEST_UNREPLIED:
      return CellsSortDirectionsEnum.DESCENDING;

    default:
      return CellsSortDirectionsEnum.ASCENDING;
  }
}

function sortPropertyFromVisualSortOption(sortOption: VisualSortOptionsEnum, hasSearch: boolean) {
  switch (sortOption) {
    case VisualSortOptionsEnum.OLDEST_UNREPLIED:
    case VisualSortOptionsEnum.NEWEST_UNREPLIED:
      return ConversationSortPropertiesEnum.WAITING_SINCE;

    case VisualSortOptionsEnum.DUE_DATE:
      return ConversationSortPropertiesEnum.EXPIRES_AT;

    default:
      return hasSearch
        ? ConversationSortPropertiesEnum.LAST_ACTIVITY_DATE
        : ConversationSortPropertiesEnum.BUMPED_AT;
  }
}
